import React, { useState } from 'react';
import {
  Box,
  Button,
  VStack,
  Heading,
  Text,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  useDisclosure
} from '@chakra-ui/react';
import { useQuery } from 'react-query';
import AdminForm from './AdminForm';
import { getAdmins } from '../../../services/adminService';
import CustomSpinner from '../../EndedAuctions/CustomSpinner';

const AdminList = () => {
  const toast = useToast();
  const { data: admins, isLoading, isError, error } = useQuery('admins', getAdmins, {
    onError: (err) => {
      toast({
        title: 'Error loading admins',
        description: err.message,
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    }
  });

  const [selectedAdminId, setSelectedAdminId] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleEdit = (id) => {
    setSelectedAdminId(id);
    onOpen();
  };

  const handleAdd = () => {
    setSelectedAdminId(null);
    onOpen();
  };

  if (isLoading) return <CustomSpinner />;
  if (isError) return <Text>Failed to load admins: {error.message}</Text>;

  return (
    <Box>
      <Button onClick={handleAdd} colorScheme="blue" mb={4}>Add New Admin</Button>
      <VStack spacing={4} align="stretch">
        {admins.map(admin => (
          <Box key={admin._id} p={5} shadow="md" borderWidth="1px">
            <Heading fontSize="xl">{admin.username}</Heading>
            <Text mt={4}>Email: {admin.email}</Text>
            <Button colorScheme="green" onClick={() => handleEdit(admin._id)}>Edit</Button>
          </Box>
        ))}
      </VStack>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedAdminId ? 'Edit Admin' : 'Create Admin'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <AdminForm onClose={onClose} adminId={selectedAdminId} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default AdminList;
